module.exports = __webpack_public_path__ + "static/media/image_corn_1.b52c9840.png";